import React, { useEffect, useState } from 'react';

import cs from 'classnames';

import { ia } from 'lib/helpers/utility';
import { useUIContext } from 'lib/context/UIContext/UIContext';
import { usePacketBuilderContext } from 'lib/context/PacketBuilder/PacketBuilderContext';

import Input from 'components/shared/Input/Input';
import StepsChart from 'components/shared/StepsChart/StepsChart';
import ErrorMessage from 'components/shared/ErrorMessage/ErrorMessage';
import ErrorBoundary, { withErrorBoundary } from 'components/shared/Error/Boundary';

import { getCurrentWithoutHidden, getStepsLeft } from '../lib/helpers';

import ItemList from './ItemList';

const Tags = ({ tagsList, currentBreadcrumb }) => {
  const { breadCrumbs, setEnableNextTo, setSearchTerm, setEnableSubmit, formik } =
    usePacketBuilderContext();
  const [selectedLength, setSelectedLength] = useState(formik.values?.tag_ids?.length);
  const { device } = useUIContext();

  const currentBreadcrumbStep = getCurrentWithoutHidden(breadCrumbs, currentBreadcrumb);
  const getBreadcrumbsLeft = getStepsLeft(breadCrumbs, currentBreadcrumb);

  useEffect(() => {
    if (selectedLength == 0) {
      setEnableSubmit(false);
      setEnableNextTo(false);
    } else {
      setEnableSubmit(true);
      setEnableNextTo(true);
    }
  }, [selectedLength]);

  const chartData = [
    { name: 'completed', value: currentBreadcrumbStep },
    { name: 'not-completed', value: getBreadcrumbsLeft }
  ];

  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <div>
        <StepsChart
          chartData={chartData}
          title="Choose tag(s)"
          description="This form packet will be sent each time selected tag(s) are applied to any new appointment."
          innerText={`${currentBreadcrumbStep}/${currentBreadcrumbStep + getBreadcrumbsLeft}`}
        />
        <div className="px-9 pt-10">
          <div className="flex items-center justify-between ">
            <p className="text-sm font-500 text-primary-900">
              Select from the list of appointment tags.
            </p>
            <div className="flex items-center gap-3">
              <p className={cs(selectedLength ? 'text-primary-900' : 'text-neutral-500')}>
                {selectedLength} selected
              </p>
              <Input
                placeholder="Search tags"
                icon="search-linear"
                rounded="full"
                width={device === 'tablet-sm' ? '250px' : '280px'}
                onChange={(e) =>
                  setSearchTerm((prevState) => ({
                    ...prevState,
                    tags: e.target.value
                  }))
                }
              />
            </div>
          </div>
          <div className="mt-[21px]">
            {ia(tagsList?.tags) &&
              tagsList?.tags?.map((tag, index) => (
                <ItemList
                  key={index}
                  item={tag}
                  options="tag_ids"
                  setSelectedLength={setSelectedLength}
                />
              ))}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default withErrorBoundary(Tags);
